let expandableImageSections = document.querySelectorAll("[data-js='expandable-image']");

expandableImageSections.forEach((expandableImageSection) => {
  let imageWrapper = expandableImageSection.querySelector(".image-wrapper");
  let toggleImageButton = expandableImageSection.querySelector(".image-toggle-button");

  toggleImageButton.addEventListener("click", () => {
    toggleImageSize();
  });

  function toggleImageSize() {
    clearTimeout(this.transitionTimeout);

    imageWrapper.classList.toggle("transition");
    imageWrapper.classList.toggle("expanded");

    toggleImageButton.innerHTML = imageWrapper.classList.contains("expanded") ? toggleImageButton.dataset.translationShrink : toggleImageButton.dataset.translationExpand;

    this.transitionTimeout = setTimeout(() => {
      imageWrapper.classList.remove("transition");
    }, 500);
  }
});
